export default __webpack_public_path__ + "e366d70661d8ad2493bd6afbd779f125.png";